import { useLayoutEffect, useRef } from "react";
export function useCSSProperty(name, value, dependencies) {
    const ref = useRef(null);
    useLayoutEffect(() => {
        if (!ref.current) {
            return;
        }
        const element = ref.current;
        element.style.setProperty(name, value);
        return () => {
            element.style.removeProperty(name);
        };
    }, dependencies);
    return ref;
}
//# sourceMappingURL=useCSSProperty.js.map